import { RpcInterceptor } from "@protobuf-ts/runtime-rpc";

import { transport } from "../../../api/grpc/grpcTransport";
import { CheckoutItem } from "../../../api/grpc/subscription/subscription";
import { ChargeBeeHostedServiceClient } from "../../../api/grpc/subscription/subscription.client";

/**
 * Creates a Chargebee hosted checkout for a cart that mixes one-time items
 * (devices, warranties, shipping) with subscription add-ons, paid in one
 * checkout on the customer's subscription. It needs at least one add-on.
 * Errors are thrown so the caller can show them.
 */
export const createCartCheckout = async (
  customerID: string,
  interceptor: RpcInterceptor,
  items: CheckoutItem[]
) => {
  const hostedServiceClient = new ChargeBeeHostedServiceClient(transport);

  const { response } = await hostedServiceClient.createCartCheckout(
    { customerID, items },
    { interceptors: [interceptor] }
  );

  return response;
};
